import { render, staticRenderFns } from "./viewInvoice.vue?vue&type=template&id=2fc04e4a&scoped=true&"
import script from "./viewInvoice.vue?vue&type=script&setup=true&lang=js&"
export * from "./viewInvoice.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./viewInvoice.vue?vue&type=style&index=0&id=2fc04e4a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc04e4a",
  null
  
)

export default component.exports